import { createAction } from '@reduxjs/toolkit'

import {
  AddPatientRequestPayload,
  AssignExistingPatientRequestPayload, GetPatientRequestPayload,
  GetPatientsSuccessPayload, GetPatientSuccessPayload, RenewProgramRequestPayload,
  StopManagePatientRequestPayload,
  StopManagePatientSuccessPayload
} from './types'

export const getPatientsRequest = createAction('GET_PATIENTS_REQUEST')
export const getPatientsSuccess = createAction<GetPatientsSuccessPayload>(
  'GET_PATIENTS_SUCCESS'
)

export const getPatientRequest = createAction<GetPatientRequestPayload>('GET_PATIENT_REQUEST')
export const getPatientSuccess = createAction<GetPatientSuccessPayload>(
  'GET_PATIENT_SUCCESS'
)
export const getPatientsFailed = createAction('GET_PATIENTS_FAILED')

export const addPatientRequest = createAction<AddPatientRequestPayload>(
  'ADD_PATIENT_REQUEST'
)

export const addPatientSuccess = createAction('ADD_PATIENT_SUCCESS')
export const addPatientFailed = createAction('ADD_PATIENT_FAILED')

export const renewProgramRequest = createAction<RenewProgramRequestPayload>(
  'RENEW_PROGRAM_REQUEST'
)

export const renewProgramSuccess = createAction('RENEW_PROGRAM_SUCCESS')
export const renewProgramFailed = createAction('RENEW_PROGRAM_FAILED')

export const assignExistingPatientRequest =
  createAction<AssignExistingPatientRequestPayload>(
    'ASSIGN_EXISTING_PATIENT_REQUEST'
  )
export const assignExistingPatientSuccess = createAction(
  'ASSIGN_EXISTING_PATIENT_SUCCESS'
)
export const assignExistingPatientFailed = createAction(
  'ASSIGN_EXISTING_PATIENT_FAILED'
)

export const stopManagePatientRequest =
  createAction<StopManagePatientRequestPayload>(
    'STOP_MANAGE_PATIENT_REQUEST'
  )
export const stopManagePatientSuccess =
  createAction<StopManagePatientSuccessPayload>(
    'STOP_MANAGE_PATIENT_SUCCESS'
  )
export const stopManagePatientFailed = createAction(
  'STOP_MANAGE_PATIENT_FAILED'
)

export const resetPatients = createAction('RESET_PATIENTS')
